<template>
	<h2>企业文化</h2>
		<iframe src="https://www.ninesleeves.online/shentoucheshi/shentoucheshi.html" style="width: 1680px;height: 860px;"></iframe>
	
</template>

<script>
</script>

<style>
</style>